import { action, observable } from 'mobx'
import { validationContext } from 'validx'
import {
  type ErrorDescriptor,
  receiveErrors,
} from '@/features/legends/editor/analyzer-errors'
import { ConfigEditorViewModelBase } from './ConfigEditorViewModelBase'
import type { PurgeConfig } from './legend-options'

/**
 * Purging of requests without activity.
 */
export class PurgeConfigEditorViewModel extends ConfigEditorViewModelBase<PurgeConfig> {
  @observable accessor enabled = false

  /**
   * Seconds.
   */
  @observable accessor purgeAfter = 0

  @observable accessor purgeDocuments = false

  readonly validation = validationContext(this, {})

  /**
   * Turns purging on or off.
   */
  @action.bound
  setEnabled(value: boolean) {
    this.enabled = value
  }

  /**
   * Sets the inactivity, in seconds, after which requests can be purged.
   */
  @action.bound
  setPurgeAfter(value: number) {
    this.purgeAfter = value
  }

  /** @inheritDoc */
  @action
  hydrate(config: PurgeConfig | undefined) {
    this.enabled = config?.enabled ?? false
    this.purgeAfter = config?.purgeAfter ?? 0
    this.purgeDocuments = config?.documents?.enabled ?? false
  }

  /** @inheritDoc */
  receiveErrors(descriptor: ErrorDescriptor) {
    const { documents, ...inner } = descriptor.inner ?? {}
    const purgeDocuments = documents?.inner?.enabled
    receiveErrors(this, { ...inner, ...(purgeDocuments && { purgeDocuments }) })
  }

  /** @inheritDoc */
  toJSON(): PurgeConfig {
    return {
      enabled: this.enabled,
      purgeAfter: this.purgeAfter,
      // Documents are the only purgeable, so they're always purged.
      documents: { enabled: true },
    }
  }
}
